import "core-js/modules/es.array.push.js";
import { getVideoDetailData } from './request';
import 'rrweb-player/dist/style.css';
import { mapState } from 'vuex';
import rrwebPlayer from 'rrweb-player';
export default {
  props: {
    record: {
      typeof: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState({
      eventData: state => state.user.eventData
    })
  },
  data() {
    return {
      visible: false,
      spinning: false,
      currentLoginId: '',
      current: 1,
      pageSize: 10,
      randomOnlyId: ''
    };
  },
  created() {
    this.randomOnlyId = new Date().getTime(); //每次打开视频的唯一key，防止上次打开请求的数据放进这次的请求数据中，造成数据混乱
    this.playVideo();
  },
  methods: {
    playVideo() {
      if (!this.record.loginId) return;
      this.currentLoginId = this.record.loginId;
      this.visible = true;
      this.spinning = true;
      let events = [];
      let randomNum = this.randomOnlyId;
      const requestVideoData = randomNum => {
        let params = {
          loginId: this.record.loginId,
          page: this.current,
          pageSize: this.pageSize
        };
        getVideoDetailData(params).then(res => {
          if (res && res.source && res.loginId === this.currentLoginId && randomNum === this.randomOnlyId && this.visible) {
            this.current++;
            let sourceEvents = JSON.parse(res.source) || [];
            events.push(...sourceEvents);
            if ((this.current - 1) * 10 >= res.totalNum) {
              this.current = 1;
              this.spinning = false;
              this.$nextTick(() => {
                if (this.visible) {
                  //确保渲染的时候有dom
                  this.player = new rrwebPlayer({
                    target: document.getElementById('playback'),
                    // 可以自定义 DOM 元素
                    props: {
                      events: events,
                      width: 800,
                      height: 500
                    }
                  });
                }
              });
            } else if (this.visible) {
              //在弹窗关闭后中断后续请求
              requestVideoData(randomNum);
            }
          }
        });
      };
      requestVideoData(randomNum);
    },
    handleOk() {
      this.player && this.player.pause();
      const replayEl = document.getElementsByClassName('rr-player')[0];
      if (replayEl) replayEl.remove();
      this.current = 1;
      this.pageSize = 10;
      this.visible = false;
      this.randomOnlyId = '';
      this.currentLoginId = '';
      this.$emit('closeModeal');
    }
  }
};